import { useEffect } from 'react';
import { useDirection } from '@hilma/netina2all';

const useChangeDirection = () => {
	const direction = useDirection();

	useEffect(() => {
		const body = document.querySelector('body');
		if (body) body.dir = direction;
	}, [direction]);
}

export default useChangeDirection;